module.exports = __webpack_public_path__ + "img/25.fcefe7f3.jpg";